export default "__VITE_ASSET__DvaiKUPy__"